<template>
  <div ref="stageRatio" :key="keyMain" class="stageRatio">
    <div v-for="(item, index) in stageItemArray" :key="index" class="stageItem">
      <el-tooltip
        :disabled="item.nameTooltipDisabled === false ? false : true"
        :placement="tooltipPlacement"
      >
        <div slot="content" class="chartItemTooltip">{{ item.name }}</div>
        <div
          class="stageItemName"
          @click="projectClick(item.id)"
          :style="'width:' + stageItemNameWidth + 'px'"
        >{{ item.name }}</div>
      </el-tooltip>
      <div class="stageItemChart">
        <template v-for="(itemChild, indexChild) in item.children">
          <!-- 只有一个阶段且未完成-->
          <div
            v-if="item.children.length === 1 && itemChild.type === 'LastUnFinshed'"
            :key="indexChild"
            class="chartItem"
            :itemIndex="index + '_' + indexChild"
          >
            <div class="chartItemTitleIcon">
              <!-- <i
                :class="chartItemIcon + ' chartItemIcon chartItemIconLast'"
                :style="'width:' + chartItemIconWidth + 'px' "
              /> -->
               
              <i
                class="el-icon-ali- chartItemIcon chartItemIconLast"
                :style="'width:' + chartItemIconWidth + 'px' "
              >&#xe642;</i>
            </div>
            <div
              class="chartItemTitleContent"
              :style="'left:' + itemChild.chartItemTitlePosLeft + 'px'"
            >
              <!-- <div class="chartItemTitle chartItemTitleLast">{{ itemChild.name }}</div> -->
              <el-tooltip
                :disabled="itemChild.titleTooltipDisabled === false ? false : true"
                :placement="tooltipPlacement"
              >
                <div slot="content" class="chartItemTooltip">{{ itemChild.name }}</div>
                <div
                  class="chartItemTitle chartItemTitleLast"
                  :style="'max-width:'+item.chartItemTitleLastMaxWidth+'px'"
                >{{ itemChild.name }}</div>
              </el-tooltip>
            </div>
          </div>

          <!-- 第一个阶段 -->
          <div
            v-else-if="indexChild === 0"
            :key="indexChild"
            class="chartItem"
            :itemIndex="index + '_' + indexChild"
          >
            <el-tooltip
              :disabled="itemChild.iconNameArray.length===0"
              popper-class="patentPoper"
              :placement="tooltipPlacement"
            >
              <div slot="content" class="chartItemTooltip">
                <div
                  v-for="(iconName, iconNameIndex) in itemChild.iconNameArray"
                  :key="iconNameIndex"
                  @click="patentClick(iconName.id)"
                  class="chartItemTooltip"
                >
                  {{ iconName.appNo }}
                  <br v-if="iconNameIndex < itemChild.iconNameArray - 1" />
                </div>
              </div>
              <div class="chartItemTitleIcon">
                <span v-if="itemChild.isCurStep" class="curr-icon-container"
                  :style="'background-color: '+getChartItemIconColor(index)"> 
                  <!-- <i 
                    :class="chartItemIconStepCur + ' chartItemIcon'"                  
                  /> -->
                  <!-- html2canvas 对伪类支持不完善,icon改为unicode方式 -->
                  <i class="el-icon-ali- chartItemIcon">&#xe606;</i> 
                </span>
                <!-- <i v-else
                  :class="(itemChild.isCurStep ? chartItemIconStepCur : chartItemIcon) + ' chartItemIcon'"
                  :style="'color: '+getChartItemIconColor(index) +';width:' + chartItemIconWidth + 'px' "
                /> -->
                <i v-else
                  class="el-icon-ali- chartItemIcon"
                  :style="'color: '+getChartItemIconColor(index) +';width:' + chartItemIconWidth + 'px' "
                >{{ (itemChild.isCurStep ? '&#xe606;' : '&#xe642;') }}</i>
              </div>
            </el-tooltip>
            <div
              class="chartItemTitleContent"
              :style="'left:' + itemChild.chartItemTitlePosLeft + 'px'"
            >
              <el-tooltip
                :disabled="itemChild.titleTooltipDisabled === false ? false : true"
                :placement="tooltipPlacement"
              >
                <div slot="content" class="chartItemTooltip">{{ itemChild.name }}</div>
                <div
                  class="chartItemTitle"
                  :style="'background-color:'+getChartItemTitleBKColor(index)+';max-width:'+item.chartItemTitleMaxWidth+'px'"
                >{{ itemChild.name }}</div>
              </el-tooltip>
              <div class="chartItemCount">
                <i :class="chartItemCountIcon + ' chartItemCountIcon'" />
                <el-tooltip
                  :disabled="itemChild.countTitleTooltipDisabled === false ? false : true"
                  :placement="tooltipPlacement"
                >
                  <div slot="content" class="chartItemTooltip">{{ itemChild.count }}</div>
                  <div
                    class="chartItemCountTitle"
                    @click="patentCountClick(item.id,itemChild.id,item.name)"
                    :style="'max-width:'+(item.chartItemTitleMaxWidth-27)+'px'"
                  >{{ itemChild.count }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>

          <!-- 不止一个阶段、最后一个、未完成的 -->
          <div
            v-if="indexChild > 0 && itemChild.type === 'LastUnFinshed'"
            :key="indexChild+'_line'"
            class="chartItemLine chartItemLineLast"
            :itemIndex="index + '_' + indexChild"
            :style="'height: '+chartItemLineHeight+'px;width:'+ item.chartItemLineLastWidth+'px;'"
          />

          <!-- 第二阶段及以后 -->
          <div
            v-else-if="indexChild > 0"
            :key="indexChild+'_line'"
            class="chartItemLine"
            :itemIndex="index + '_' + indexChild"
            :style="(itemChild.lineBorderRadius ? itemChild.lineBorderRadius : '') + 'height: '+chartItemLineHeight+'px;width:'+ item.chartItemLineWidth+'px;background-color: '+getChartItemLineBKColor(index) +';border-color: '+getChartItemLineBKColor(index) +';'"
          />

          <!-- 不止一个阶段、最后一个、未完成的 -->
          <div
            v-if="indexChild > 0 && itemChild.type === 'LastUnFinshed'"
            :key="indexChild"
            class="chartItem"
            :itemIndex="index + '_' + indexChild"
          >
            <div class="chartItemTitleIcon">
              <!-- <i
                :class="chartItemIcon + ' chartItemIcon chartItemIconLast'"
                :style="'width:' + chartItemIconWidth + 'px' "
              /> -->
              <i
                class="el-icon-ali-  chartItemIcon chartItemIconLast"
                :style="'width:' + chartItemIconWidth + 'px' "
              >&#xe642;</i>
            </div>
            <div
              class="chartItemTitleContent"
              :style="'left:' + itemChild.chartItemTitlePosLeft + 'px'"
            >
              <!-- <div class="chartItemTitle chartItemTitleLast">{{ itemChild.name }}</div> -->
              <el-tooltip
                :disabled="itemChild.titleTooltipDisabled === false ? false : true"
                :placement="tooltipPlacement"
              >
                <div slot="content" class="chartItemTooltip">{{ itemChild.name }}</div>
                <div
                  class="chartItemTitle chartItemTitleLast"
                  :style="'max-width:'+item.chartItemTitleLastMaxWidth+'px'"
                >{{ itemChild.name }}</div>
              </el-tooltip>
            </div>
          </div>
          <!-- 第二阶段及以后 -->
          <div
            v-else-if="indexChild > 0 && (itemChild.count > 0 || itemChild.isCurStep)"
            :key="indexChild"
            class="chartItem"
            :itemIndex="index + '_' + indexChild"
          >
            <el-tooltip
              :disabled="itemChild.iconNameArray.length===0"
              popper-class="patentPoper"
              :placement="tooltipPlacement"
            >
              <div slot="content" class="chartItemTooltip">
                <div
                  v-for="(iconName, iconNameIndex) in itemChild.iconNameArray"
                  :key="iconNameIndex"
                  @click="patentClick(iconName.id)"
                  class="chartItemTooltip"
                >
                  {{ iconName.appNo }}
                  <br v-if="iconNameIndex < itemChild.iconNameArray - 1" />
                </div>
              </div>
              <div class="chartItemTitleIcon">
                <span v-if="itemChild.isCurStep" class="curr-icon-container"
                  :style="'background-color: '+getChartItemIconColor(index)"> 
                  <!-- <i 
                    :class="chartItemIconStepCur + ' chartItemIcon'"                  
                  /> -->
                  <i class="el-icon-ali- chartItemIcon">&#xe606;</i> 
                </span>
                <!-- <i v-else
                  :class="(itemChild.isCurStep ? chartItemIconStepCur : chartItemIcon) + ' chartItemIcon'"
                  :style="'color: '+getChartItemIconColor(index) +';width:' + chartItemIconWidth + 'px' "
                /> -->
                <i v-else
                  class="el-icon-ali- chartItemIcon"
                  :style="'color: '+getChartItemIconColor(index) +';width:' + chartItemIconWidth + 'px' "
                >{{ (itemChild.isCurStep ? '&#xe606;' : '&#xe642;') }}</i>
              </div>
            </el-tooltip>
            <div
              class="chartItemTitleContent"
              :style="'left:' + itemChild.chartItemTitlePosLeft + 'px'"
            >
              <el-tooltip
                :disabled="itemChild.titleTooltipDisabled === false ? false : true"
                :placement="tooltipPlacement"
              >
                <div slot="content" class="chartItemTooltip">{{ itemChild.name }}</div>
                <div
                  class="chartItemTitle"
                  :style="'background-color:'+getChartItemTitleBKColor(index)+';max-width:'+(indexChild<item.children.length-1 ?item.chartItemTitleMaxWidth:item.chartItemTitleLastMaxWidth)+'px'"
                >{{ itemChild.name }}</div>
              </el-tooltip>
              <div class="chartItemCount">
                <i :class="chartItemCountIcon + ' chartItemCountIcon'" />
                <el-tooltip
                  :disabled="itemChild.countTitleTooltipDisabled === false ? false : true"
                  :placement="tooltipPlacement"
                >
                  <div slot="content" class="chartItemTooltip">{{ itemChild.count }}</div>
                  <div
                    class="chartItemCountTitle"
                    @click="patentCountClick(item.id,itemChild.id,item.name)"
                    :style="'max-width:'+((indexChild<item.children.length-1 ?item.chartItemTitleMaxWidth:item.chartItemTitleLastMaxWidth)-27)+'px'"
                  >{{ itemChild.count }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>

          <!-- 第二阶段及以后，如果不显示，则显示线条 -->
          <div
            v-else-if="indexChild > 0 && itemChild.count == 0 && !itemChild.isCurStep"
            :key="indexChild+'_noPatent_line'"
            class="chartItemLine"
            :itemIndex="index + '_' + indexChild"
            :style="(itemChild.borderRadius ? itemChild.borderRadius : '') +'height: '+chartItemLineHeight+'px;width:'+ chartItemIconWidth+'px;background-color: '+getChartItemLineBKColor(index) +';border-color: '+getChartItemLineBKColor(index) +';'"
          />
        </template>
      </div>
      <!-- <div class="stageItemName" :style="'width:' + stageItemNameWidth + 'px'">
              项目1
          </div>
          <div class="stageItemChart">
              <div class="chartItem">
                  <div class="chartItemTitleIcon">
                    <i :class="chartItemIcon + ' chartItemIcon'" :style="'color: red;width:' + chartItemIconWidth + 'px' "/>
                  </div>
                  <div class="chartItemTitleContent" :style="'left:'+chartItemTitlePosLeft">
                      <div class="chartItemTitle" :style="'background-color:rgba(245,34,45,0.1);max-width:'+chartItemTitleMaxWidth+'px'">
                         sdffffffffabcdef ddddddddddddddddddd
                      </div>
                      <div class="chartItemCount">
                         <i :class="chartItemCountIcon + ' chartItemCountIcon'"/>
                         <div class="chartItemCountTitle" :style="'max-width:'+(chartItemTitleMaxWidth-7)+'px'">23223</div>
                      </div>
                  </div>
              </div>
              <div class="chartItemLine" :style="'height: '+chartItemLineHeight+'px;width:'+ chartItemLineWidth+'px;background-color: red;border-color: red;'">
              </div>
              <div class="chartItem">
                  <div class="chartItemTitleIcon">
                    <i :class="chartItemIcon + ' chartItemIcon'" style="color: red;"/>
                  </div>
                  <div class="chartItemTitleContent" :style="'left:'+chartItemTitlePosLeft">
                      <div class="chartItemTitle" :style="'background-color:rgba(245,34,45,0.1);max-width:'+chartItemTitleMaxWidth+'px'">
                         sdffffffffabcdef ddddddddddddddddddd
                      </div>
                      <div class="chartItemCount">
                         <i :class="chartItemCountIcon + ' chartItemCountIcon'"/>
                         <div class="chartItemCountTitle" :style="'max-width:'+(chartItemTitleMaxWidth-7)+'px'">23223</div>
                      </div>
                  </div>
              </div>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    chartItemIcon: {
      // 图表中的图标
      type: String,
      default: "el-icon-caret-bottom"
    },
    chartItemIconStepCur: {
      // 图表中当前步骤的图标
      type: String,
      default: "el-icon-ali-"//"el-icon-ali-arrow_rt"//"el-icon-location-information"
    },
    chartItemCountIcon: {
      // 图表中数量的图标
      type: String,
      default: "el-icon-ali-project"
    },
    chartItemLineHeight: {
      // 图表连接线高度
      type: Number || String,
      default: 4
    },
    stageItemMaxCount: {
      // 项目最大显示数量
      type: Number,
      default: 4
    },
    stageItemNameMinWidth: {
      // 项目名称最小宽度
      type: Number,
      default: 100
    }, 
    stageItemData: {
      // 图表项数据
      type: Array,
      default: () => {
        return [
          //   {
          //       name: '项目1',
          //       totalCount: 6,
          //       nameTooltipDisabled: true,
          //       children: [
          //           {
          //               name: '阶段1',
          //               count: 2,
          //               content: 'aaaaaa',
          //               titleDisabled: true,
          //               countTitleDisabled: true
          //           }
          //       ]
          //   },
          //   {
          //       name: '项sdfdfgdfgsgsgsf目1',
          //       totalCount: 6,
          //       children: [
          //           {
          //               name: '阶sfsdsdfsdfsfa段1',
          //               count: 2,
          //               content: 'aaaaaa',
          //               iconNameArray: ['aaaaaa']
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 3,
          //               content: 'bbbb',
          //               iconNameArray: ['bbbb']
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 6
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 1
          //           }
          //       ]
          //   },
          //   {
          //       name: '项sdfdfgdfgsgsgsf目1',
          //       totalCount: 13,
          //       children: [
          //           {
          //               name: '阶sfsdsdfsdfsfa段1',
          //               count: 2
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 3
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 6
          //           },
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 1
          //           }
          //       ]
          //   },
          //   {
          //       name: '项sdfdfgdfgsgsgsf目1',
          //       totalCount: 1,
          //       children: [
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 1
          //           }
          //       ]
          //   },
          //   {
          //       name: '项sdfdfgdfgsgsgsf目1',
          //       totalCount: 1,
          //       children: [
          //           {
          //               name: '阶sfsdsdfsdfsfa段2',
          //               count: 1
          //           }
          //       ]
          //   }
        ];
      }
    }
  },
  data() {
    return {
      keyMain: 0,
      tooltipPlacement: "top-start", // Tooltip 的出现位置
      stageItemNameWidth: 100, // 项目名称宽度
      chartItemIconWidth: 30, // 图表中的图标宽度
      chartItemTitlePosLeft: "-50px", // 图表标题相对图标的偏移量
      chartItemTitleMaxWidth: 100, // 图表标题最大宽度
      chartItemTitleLastMaxWidth: 100, // 图表最后一个标题最大宽度
      chartItemLineMinWidthFixed: 40, // 图表连接线最小宽度，固定值
      chartItemLineWidth: 100, // 图表连接线宽度
      chartItemLineLastWidth: 100, // 图表最后一条连接线宽度
      chartItemLineColorArray: [
        // 图表连接线颜色集合
        "rgba(225,73,81,1)",
        "rgba(249,182,32,1)",
        "rgba(30,124,241,1)",
        "rgba(93,195,92,1)"
      ],
      chartItemTitleBKColorArray: [
        // 图表中的标题背景色集合
        "rgba(245,34,45,0.1)",
        "rgba(249,182,32,0.1)",
        "rgba(30,124,241,0.1)",
        "rgba(93,195,92,0.1)"
      ],
      stageItemArray: [] // 图表项数据集合
    };
  },
  computed: {},
  watch: {
    stageItemData() {
      this.loadData();
    }
  },
  created() {},
  mounted() {    
    const _self = this;
    let timeoutObj = 0
    let timeoutFun = function(){
      window.clearTimeout(timeoutObj)
      const stageRatio = document.getElementsByClassName("stageRatio");
      // console.log(stageRatio[0].clientWidth,'b',stageRatio[0].offsetWidth)
      if (stageRatio && stageRatio.length > 0) {
        let stageRatioWidth = _self.getStageRatioWidth()
        if(stageRatioWidth > 0){
          _self.loadData();
        }
        else{
          timeoutObj = window.setTimeout(timeoutFun, 100)
        }
      }
    }
    timeoutObj = window.setTimeout(timeoutFun, 100)

    window.addEventListener("resize", () => {
      _self.loadData();
      // _self.update();
    });
  },
  methods: {
    update() {
      this.keyMain++;
    },
    loadData(stageItemChartMaxWidth) {
      // 加载数据
      this.loadStageItemNameWidth(); // 加载项目名称div的宽度

      const stageItemData = this.stageItemData;
      if (
        stageItemData !== undefined &&
        stageItemData !== null &&
        stageItemData.length > 0
      ) {
        const stageItemDataNew = [];
        let chartItemMaxWidth = this.getStageItemChartMaxWidth(); // 图表总宽度
        if (
          stageItemChartMaxWidth &&
          stageItemChartMaxWidth > chartItemMaxWidth
        ) {
          // 传入的参数大于当前图表宽度，则用传入的参数
          chartItemMaxWidth = stageItemChartMaxWidth;
        }
        let chartItemMaxWidthNew = chartItemMaxWidth;
        const maxIndex =
          stageItemData.length > this.stageItemMaxCount
            ? this.stageItemMaxCount
            : stageItemData.length;
        this.chartItemTitleMaxWidth = this.getChartItemTitleMaxWidth(); // 通过计算的默认长度
        this.chartItemTitleLastMaxWidth = (this.chartItemLineMinWidthFixed * 2 + this.chartItemIconWidth)//图表最后一个标题最大宽度
        const chartItemMaxWidthJS = this.chartItemTitleLastMaxWidth / 2 + 25;//60; // 需要减少的值
        for (let i = 0; i < maxIndex; i++) {
          const stageItem = Object.assign({}, stageItemData[i]);
          stageItemDataNew.push(stageItem);
          let children = stageItem.children; // 图表项集合
          let totalCount = stageItem.totalCount; // 总数量
          let childrenLength = 0;
          if (children !== undefined && children !== null) {
            children = [];
            let childHasCountLast = null//上一个有count的阶段
            for (let m = 0; m < stageItem.children.length; m++) {
              const child = Object.assign({}, stageItem.children[m]);
              children.push(child);
              if(child.count == 0 && !child.isCurStep){
                //没有专利，当前的整个不用圆角     
                child.borderRadius = "border-radius: 0;";//当前的整个不用圆角

                //当前没有专利，则上一个线条右边不用圆角
                child.lineBorderRadius = "border-radius: 8px 0 0 8px;";//右边不用圆角
              }
              if(m > 1 && childHasCountLast && childHasCountLast.count == 0 && !childHasCountLast.isCurStep){
                //上一个没有专利，则当前图形左边边不用圆角
                //由于第一条线左边必然是圆角，所以不做修改，从第3个图形开始判断
                if(child.lineBorderRadius){
                  child.lineBorderRadius = "border-radius: 0;";//整个不用圆角
                }
                else{
                  child.lineBorderRadius = "border-radius: 0 8px 8px 0;"//左边不用圆角
                }
              }
              childHasCountLast = child
            }
            childrenLength = children.length;
          } else {
            children = [];
            childrenLength = children.length;
          }
          stageItem.children = children;
          if (totalCount > childrenLength) {
            // // 总数量大于图表项数量，则添加一个最终项
            // const chartItemLast = {
            //   type: "LastUnFinshed",
            //   name: "Litigation"
            // }; // 最终项
            // children.push(chartItemLast);
          } 
          else if (totalCount < childrenLength) {
            totalCount = childrenLength;
            stageItem.totalCount = totalCount;
          }
          let isChartItemTitleMaxWidth = false//是否按照图标标题最大宽度设置宽度
          if(children.filter(child => { return child.count > 0 || child.isCurStep || child.type == 'LastUnFinshed' }).length == 2){
            //实际显示的个数只有两个时
            isChartItemTitleMaxWidth = true
          }
          if (children.length > 1) {
            // 不止一个阶段才计算线长
            const chartItemCountAll = children.length; // 图表项数量
            const chartItemCountNoUnF =
              children[chartItemCountAll - 1].type === "LastUnFinshed"
                ? chartItemCountAll - 1
                : chartItemCountAll; // 不包括最后一项未完成的图表项数量
            const chartItemMaxWidthTemp =
              chartItemMaxWidth - chartItemMaxWidthJS;
            const chartItemLineTotalWidth =
              chartItemMaxWidthTemp -
              this.chartItemIconWidth * chartItemCountAll; // 图标连接线总长度=图表总宽度-图表项图标宽度*图表项数量
            let chartItemLineWidth = chartItemLineTotalWidth / (totalCount - 1); // 图表连接线长度=图标连接线总长度/理论连接线数量
            let chartItemLineLastWidth =
              chartItemLineTotalWidth -
              chartItemLineWidth * (chartItemCountNoUnF - 1); // 图表最后一条连接接线宽度=图标连接线总长度-图表连接线长度*连接线数量
            let chartItemTitleMaxWidth =
              (chartItemLineWidth * 2 + this.chartItemIconWidth) / 2 - 10; // 图标标题最大宽度
            const chartItemTitleMaxWidthD = this.chartItemTitleMaxWidth
            if(isChartItemTitleMaxWidth){
              chartItemTitleMaxWidth = chartItemTitleMaxWidthD;//按照图标标题最大宽度设置宽度
            }
            if (chartItemLineWidth < this.chartItemLineMinWidthFixed) {
              chartItemLineWidth = this.chartItemLineMinWidthFixed; // 小于固定最小宽度，则用固定最小宽度
              chartItemLineLastWidth =
                chartItemLineWidth * (totalCount - chartItemCountNoUnF) +
                this.chartItemIconWidth *
                  (totalCount - chartItemCountNoUnF - 1); // 图表最后一条连接接线宽度=图标连接线总长度-图表连接线长度*连接线数量
              const chartItemMaxWidthCur =
                chartItemLineWidth * (chartItemCountNoUnF - 1) +
                chartItemLineLastWidth +
                this.chartItemIconWidth * chartItemCountAll +
                chartItemMaxWidthJS; // 当前总宽度
              if (chartItemMaxWidthNew < chartItemMaxWidthCur) {
                chartItemMaxWidthNew = chartItemMaxWidthCur;
              }
            }
            if (chartItemTitleMaxWidth > chartItemTitleMaxWidthD) {
              chartItemTitleMaxWidth = chartItemTitleMaxWidthD;
            }
            let chartItemTitleLastMaxWidth = chartItemTitleMaxWidth
            if(chartItemTitleLastMaxWidth > this.chartItemTitleLastMaxWidth){
              chartItemTitleLastMaxWidth = this.chartItemTitleLastMaxWidth
            }
            
            stageItem.chartItemLineWidth = chartItemLineWidth;
            stageItem.chartItemLineLastWidth = chartItemLineLastWidth;
            stageItem.chartItemTitleMaxWidth = chartItemTitleMaxWidth - 2;
            stageItem.chartItemTitleLastMaxWidth = chartItemTitleLastMaxWidth - 2;
            // stageItem.chartItemIconColor = this.getChartItemIconColor(i)
            // stageItem.chartItemTitleBKColor = this.getChartItemTitleBKColor(i)
            // stageItem.chartItemLineBKColor = this.getChartItemLineBKColor(i)
          } 
          else {
            stageItem.chartItemLineWidth = this.chartItemLineWidth;
            stageItem.chartItemLineLastWidth = this.chartItemLineLastWidth;
            stageItem.chartItemTitleMaxWidth = this.chartItemTitleMaxWidth;
            stageItem.chartItemTitleLastMaxWidth = this.chartItemTitleMaxWidth;//this.chartItemTitleLastMaxWidth;
          }
        }

        if (chartItemMaxWidthNew > chartItemMaxWidth) {
          // 如果最大宽度大于当前宽度，则重新加载
          this.loadData(chartItemMaxWidthNew);
          return;
        }

        this.stageItemArray = stageItemDataNew; // 图表项数据集合

        const _self = this;
        const timeoutObj = window.setTimeout(function() {
          _self.computeStageItemAuto(); // 计算图表项自适应
          window.clearTimeout(timeoutObj);
        }, 10);
      }
      else{
        this.stageItemArray = []
      }
    },
    computeStageItemAuto() {
      // 计算图表项自适应
      // 计算图表标题相对图标的偏移量
      let isUpdate = false;
      const chartItemTitleArray = document.getElementsByClassName(
        "chartItemTitle"
      );
      const chartItemTitleContentArray = document.getElementsByClassName(
        "chartItemTitleContent"
      );
      //   console.log(chartItemTitleArray)
      //   console.log(chartItemTitleArray[0].parentElement.parentElement.attributes.getNamedItem('itemIndex'))
      //   console.log(chartItemTitleContentArray.item(0).style.setProperty)
      if (
        chartItemTitleArray !== undefined &&
        chartItemTitleArray !== null &&
        chartItemTitleArray.length > 0
      ) {
        for (let i = 0; i < chartItemTitleArray.length; i++) {
          const chartItemTitle = chartItemTitleArray[i];
          const chartItemTitleWidth = chartItemTitle.clientWidth;
          const itemIndex = chartItemTitle.parentElement.parentElement.attributes.getNamedItem(
            "itemIndex"
          );
          const itemChildObj = this.getStageItemChildByItemIndex(itemIndex);
          if (chartItemTitleWidth < chartItemTitle.scrollWidth) {
            //   chartItemTitle.title = chartItemTitle.innerText
            if (itemChildObj !== null) {
              itemChildObj.titleTooltipDisabled = false; // 标题显示文字过多提示
              isUpdate = true;
            }
          }
          const chartItemTitlePosLeft = -(chartItemTitleWidth - this.chartItemIconWidth) / 2;
          //   chartItemTitleContentArray[i].style.setProperty(
          //     "left",
          //     chartItemTitlePosLeft.toString() + "px"
          //   ); //设置左偏移
          if (itemChildObj !== null) {
            itemChildObj.chartItemTitlePosLeft = chartItemTitlePosLeft;
            isUpdate = true;
          }
        }
      }

      const chartItemCountTitleArray = document.getElementsByClassName(
        "chartItemCountTitle"
      );
      if (
        chartItemCountTitleArray !== undefined &&
        chartItemCountTitleArray !== null &&
        chartItemCountTitleArray.length > 0
      ) {
        for (let i = 0; i < chartItemCountTitleArray.length; i++) {
          const chartItemCountTitle = chartItemCountTitleArray[i];
          const chartItemCountTitleWidth = chartItemCountTitle.clientWidth;
          if (chartItemCountTitleWidth < chartItemCountTitle.scrollWidth) {
            //   chartItemCountTitle.title = chartItemCountTitle.innerText
            const itemIndex = chartItemCountTitle.parentElement.parentElement.parentElement.attributes.getNamedItem(
              "itemIndex"
            );
            const itemChildObj = this.getStageItemChildByItemIndex(itemIndex);
            if (itemChildObj !== null) {
              itemChildObj.countTitleTooltipDisabled = false; // 数量标题显示文字过多提示
              isUpdate = true;
            }
          }
        }
      }

      const stageItemNameArray = document.getElementsByClassName(
        "stageItemName"
      );
      if (
        stageItemNameArray !== undefined &&
        stageItemNameArray !== null &&
        stageItemNameArray.length > 0
      ) {
        for (let i = 0; i < stageItemNameArray.length; i++) {
          const stageItemName = stageItemNameArray[i];
          const stageItemNameWidth = stageItemName.clientWidth;
          if (stageItemNameWidth < stageItemName.scrollWidth) {
            //   stageItemName.title = stageItemName.innerText
            this.stageItemArray[i].nameTooltipDisabled = false; // 项目名称显示文字过多提示
            isUpdate = true;
          }
        }
      }

      if (isUpdate) {
        this.update();
      }
    },
    loadStageItemNameWidth() {
      // 加载项目名称div的宽度
      const stageRatio = document.getElementsByClassName("stageRatio");
      // console.log(stageRatio)
      let width = this.stageItemNameMinWidth;
      let minWidth = this.stageItemNameMinWidth;
      if (stageRatio && stageRatio.length > 0) {
        const stageRatioWidth = this.getStageRatioWidth()//stageRatio[0].clientWidth; // 总宽度
        width = stageRatioWidth * 0.10;
      }
      if (width < minWidth) {
        width = minWidth; // 宽度
      }

      this.stageItemNameWidth = width;
    },
    getStageItemChildByItemIndex(itemIndex) {
      // 根据序号获取阶段子对象
      let item = null;
      const stageItemArray = this.stageItemArray;
      if (
        stageItemArray === undefined ||
        stageItemArray === null ||
        stageItemArray.length === 0 ||
        itemIndex === undefined ||
        itemIndex === null ||
        itemIndex === ""
      ) {
        return item;
      }

      const indexStr =
        typeof itemIndex === "object" ? itemIndex.value : itemIndex;
      const indexArray = indexStr.split("_");
      if (indexArray.length > 1) {
        item = stageItemArray[indexArray[0]].children[indexArray[1]];
      } else {
        item = stageItemArray[indexArray[0]];
      }

      return item;
    },
    getStageRatioWidth(){
      //获取当前组件的宽度
      const stageRatio = document.getElementsByClassName("stageRatio");
      let stageRatioWidth = 0
      if (stageRatio && stageRatio.length > 0) {
        stageRatioWidth = stageRatio[0].clientWidth;
        if(stageRatioWidth == 0){
          stageRatioWidth = stageRatio[0].offsetWidth
        }
      }

      return stageRatioWidth
    },
    getStageItemChartMaxWidth() {
      // 获取项目图表最大宽度
      const stageRatio = document.getElementsByClassName("stageRatio");
      let maxWidth = 100;
      if (stageRatio && stageRatio.length > 0) {
        const stageRatioWidth = this.getStageRatioWidth()//stageRatio[0].clientWidth; // 总宽度
        maxWidth = stageRatioWidth - this.getStageItemNameWidth(); // 图表最大宽度=总宽度-项目名称宽度
      }
      if (maxWidth < 100) {
        maxWidth = 100;
      }

      return maxWidth;
    },
    getStageItemNameWidth() {
      // 获取项目名称div的宽度
      //   let stageItemName = document.getElementsByClassName("stageItemName");
      //   let width = 100;
      //   if (stageItemName.length > 0) {
      //     width = stageItemName[0].clientWidth; //宽度
      //   }
      // 宽度需要加上padding
      return this.stageItemNameWidth + 15; // width
    },
    getChartItemTitleMaxWidth() {
      // 获取图表标题最大宽度
      const stageItemNameWidth = this.getStageItemNameWidth();
      const width = stageItemNameWidth + this.chartItemIconWidth - 2;
      return width;
    },
    getChartItemIconColor(index) {
      // 根据序号获取图标颜色
      return this.getChartItemLineBKColor(index);
    },
    getChartItemTitleBKColor(index) {
      // 根据序号获取图表标题颜色
      const chartItemTitleBKColorArray = this.chartItemTitleBKColorArray;
      const colorIndex = index % chartItemTitleBKColorArray.length;
      const color = chartItemTitleBKColorArray[colorIndex];
      return color;
    },
    getChartItemLineBKColor(index) {
      // 根据序号获取图表连接线颜色
      const chartItemLineColorArray = this.chartItemLineColorArray;
      const colorIndex = index % chartItemLineColorArray.length;
      const color = chartItemLineColorArray[colorIndex];
      return color;
    },

    projectClick(projectId) {
      this.$emit("projectClick", projectId);
    },
    patentCountClick(projectId,phaseId,projectName) {
      this.$emit("patentCountClick",projectId,phaseId,projectName);
    },
    patentClick(id) {
      this.$emit("patentClick", id);
    }
  }
};
</script>
<style lang="scss" scoped>
.stageRatio {
  min-width: 200px;
  line-height: 30px;
  position: relative;
  overflow-x: auto;
  // overflow-y: visible;
}

.stageItem {
  display: flex;
  // flex-wrap: nowrap;
  align-items: flex-start;
  min-height: 110px;
  margin: 10px auto;
}

/* 阶段名称 */
.stageItemName {
  word-break: keep-all;
  word-wrap: normal;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  line-height: 34px;//44px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(84, 84, 84, 1);
  // padding-top: 5px;
  // padding-bottom: 5px;
  // min-width: 100px;
  min-width: 100px;
  //   max-width: 15%;
  padding-right: 15px;
  cursor: pointer;
}

.stageItemChart {
  display: flex;
  // flex-wrap: nowrap;
  // justify-content: flex-start | flex-end | center | space-between | space-around;
  align-items: center; //flex-start | flex-end | center | baseline | stretch;
}

.chartItem {
  position: relative;
}

.chartItemTitleIcon {
  // padding-bottom: 5px;
  // width: 30px;
  text-align: center;
}

.curr-icon-container {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    // background-color: white;
    background-color:rgba(245,166,35,1);
    margin: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    // text-align: center;
    padding-right:1px;

    i{
      color: white;
      font-size: 12px;
    }
  }

.chartItemIcon {
  font-size: 30px;
}

.chartItemIconLast {
  font-size: 30px;
  color: rgba(245, 245, 245, 1);
}

/* 阶段图标提示 */
.chartItemTooltip {
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
}

.chartItemTitleContent {
  position: absolute;
  top: 35px;
  left: -50%;
}

/* 阶段图标下的标题 */
.chartItemTitle {
  // max-width: 200px;
  line-height: 30px;
  border-radius: 15px;
  padding: 0px 10px;
  word-break: keep-all;
  word-wrap: normal;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  // opacity:0.05;
  // -moz-opacity:0.5;
  // filter:alpha(opacity=50);
}

.chartItemTitleLast {
  // width: 90px;
  // text-align: center;
  // font-size: 12px;
  color: rgba(204, 204, 204, 1);
}

.chartItemCount {
  text-align: center;
  color: rgba(5, 124, 191, 1);
  display: flex;
  justify-content: center;
  margin-top: 1px;
  padding: 0 10px;
}

/* 阶段图标下的数量图标 */
.chartItemCountIcon {
  font-size: 18px;
  line-height: inherit;
}

/* 阶段图标下的数量标题 */
.chartItemCountTitle {
  font-size: 16px;
  margin-left: 5px;
  word-break: keep-all;
  word-wrap: normal;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.chartItemLine {
  // border-width: 1px;
  // border-style: solid;
  border-radius: 8px;
}

.chartItemLineLast {
  // border-width: 1px;
  // border-style: solid;
  border-radius: 8px;
  background-color: rgba(245, 245, 245, 1);
}
</style>
<style>
.patentPoper {
  background: #2f6f95 !important;
}

.patentPoper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #2f6f95 !important;
}
</style>
